<mat-select [required]="to.required" [placeholder]="to.placeholder" [multiple]="to.isMultiSelect" [formlyAttributes]="field"
  [disabled]="to.disabled || to.readonly" [(value)]="selectedValue" (selectionChange)="onSelectedChange($event)"
  (opened)="onOpen()"
  (closed)="onClosed()"
  (focus)="onFocusIn()" (blur)="onFocusOut()">
  <ng-container *ngIf="to.objectChooserOptions?.length; else empty">
    <mat-form-field class="search-full-width">
      <mat-label>Search</mat-label>
      <input  type="text" matInput placeholder="Type to search" [formControl]="searchBar" (keydown)="$event.stopPropagation()" #fromFieldInput>
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
    <mat-option *ngFor="let item of to.objectChooserOptions" [value]="item?.value">{{item.label | i18n_label}}
    </mat-option>
    <div class="button-style" *ngIf="!showMoreHide">
      <button mat-raised-button class="btn basic" type="button" (click)="showMoreObjects()">{{ 'Show More' | translate
        }}</button>
    </div>
  </ng-container>
  <ng-template #empty>
    <mat-form-field class="search-full-width">
      <mat-label>Search</mat-label>
      <input type="text" matInput placeholder="Type to search" [formControl]="searchBar"
        (keydown)="$event.stopPropagation()">
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
    <div class="options-style">
      <mat-option disabled>No options to select</mat-option>
    </div>
  </ng-template>
</mat-select>
